var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-header"}),_c('div',{staticClass:"page-body-wrapper"},[_c('div',{staticClass:"page-body"},[_c('transition',{attrs:{"enter-active-class":""}},[_c('router-view',{staticClass:"view"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }